angular.module('app.controllers').controller('ApprovePhasesCtrl', function ($scope, $stateParams, $http, $window) {
    $scope.type = $stateParams.type;
    $scope.week = $stateParams.week;

    $scope.dateFrom = moment().week($scope.week).startOf('week');
    $scope.dateTo = moment().week($scope.week).endOf('week');

    $scope.previousWeek = $scope.dateFrom.clone().subtract(6, 'days').week();
    $scope.nextWeek = $scope.dateTo.clone().add(6, 'days').week();

    $scope.weekPhases = {};

    const loadData = () => {
        $http.get(`/api/1/phases/limits/get/${$scope.type}/${$scope.dateFrom.format('YYYY-MM-DD')}`).then((response) => {
            $scope.weekPhases = response.data;
        });
    };

    $scope.updateLockStatus = (day, lock) => {
        $http.post(`/api/1/phases/limits/update-limit/${$scope.type}/${day}/${lock ? 1 : 0}`).then(() => {
            loadData();
        });
    };

    $scope.updateApproval = (id, status) => {
        $http.post(`/api/1/phases/limits/update-phase/${id}/${status ? 1 : 0}`).then(() => {
            loadData();
        });
    };

    $scope.formatDay = (day) => moment(day).format('DD.MM, dddd');
    $scope.isLocked = (limit) => limit === 0;
    $scope.canBeChanged = (date) => date >= moment().format('YYYY-MM-DD');

    loadData();
});
